//libs
import { styled } from '@nykaa/ui-components';

const ColorContainer = styled.div`
  ${({ theme }) =>
    `width: ${theme.spacing.spacing100};
    height: ${theme.spacing.spacing100};
    border-radius: ${theme.spacing.spacing20};
    border: 1px solid ${theme.colors.surface30};
    margin-right: ${theme.spacing.spacing40};
`};
`;

export const ColorBox = styled(ColorContainer)<{ colorCode: string }>`
  ${({ colorCode }) => colorCode && `background-color: ${colorCode};`};
`;

export const ImageBox = ColorContainer.withComponent('img');
